export default __webpack_public_path__ + "static/media/fabien-bazanegue.d33f4020.jpg";